import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
} from '@fluentui/react-components';
import {
  Delete20Regular,
  Edit20Regular,
  MoreHorizontal20Regular,
} from '@fluentui/react-icons';

/**
 * Composant label pour le nœud Queue
 * Accepte soit routing/routingKey (routing normal) soit optionData (nœud terminal)
 */
const QueueNodeLabel = ({ routingKey, routing, optionData, handleEditNode, handleDeleteNode }) => {
  const { t } = useTranslation();
  // Si c'est un nœud terminal (optionData existe)
  if (optionData) {
    const nodeId = `queue-${optionData.queueId}`;
    const queueName = optionData.queueDisplayName || optionData.displayName || 'N/A';
    
    return (
      <div className="node-queue">
        <Menu>
          <MenuTrigger disableButtonEnhancement>
            <button
              className="node-menu-btn"
              onClick={(e) => e.stopPropagation()}
              title="Options"
            >
              <MoreHorizontal20Regular />
            </button>
          </MenuTrigger>
          <MenuPopover>
            <MenuList>
              <MenuItem
                icon={<Delete20Regular />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteNode(nodeId);
                }}
              >
                {t('DELETE')}
              </MenuItem>
            </MenuList>
          </MenuPopover>
        </Menu>
        <div className="node-title">{t('QUEUE')}</div>
        <div className="node-separator"></div>
        <div className="node-info">
          <div className="node-info-item" style={{ fontWeight: 600 }}>{queueName}</div>
        </div>
      </div>
    );
  }
  
  // Sinon, c'est un routing normal
  const routingId = routingKey === '0' ? 'routing-0' : `routing-${routingKey}`;
  const displayName = routingKey === '0' ? t('START') : (routing?.displayName || routing?.routingName || routingKey);
  const queueName = routing?.queueDisplayName || routing?.displayName || 'N/A';
  const isDefaultRouting = routingKey === '0';

  return (
    <div className="node-queue">
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <button
            className="node-menu-btn"
            onClick={(e) => e.stopPropagation()}
            title="Options"
          >
            <MoreHorizontal20Regular />
          </button>
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem
              icon={<Edit20Regular />}
              onClick={(e) => {
                e.stopPropagation();
                handleEditNode(routingId);
              }}
            >
              {t('EDIT')}
            </MenuItem>
            {!isDefaultRouting && (
              <MenuItem
                icon={<Delete20Regular />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteNode(routingId);
                }}
              >
                {t('DELETE')}
              </MenuItem>
            )}
          </MenuList>
        </MenuPopover>
      </Menu>
      <div className="node-title">{displayName}</div>
      <div className="node-separator"></div>
      <div className="node-info">
        <div className="node-info-item">{t('QUEUE')}</div>
        <div className="node-info-item" style={{ fontWeight: 600 }}>{queueName}</div>
      </div>
    </div>
  );
};

export default QueueNodeLabel;
